module.exports = __webpack_public_path__ + "media/images/icon_login_1-3010aab9d79c8a0841c9d40825881e90.png";